import "./PeopleSelectorWidget.css"

const DEFAULT_PERSON_OPTIONS = ["Individual", "Group"];

function PeopleSelectorWidget({value, onChange, options=DEFAULT_PERSON_OPTIONS, ariaLabel}){
    return(
        <div role="tablist">
            {options.map((option) => {
                return(
                    <button
                    key={option}
                    type="button"
                    className={`people-selector__button${value === option ? " is-active" : ""}`}
                    onClick={() => onChange(option)}
                    aria-selected={value === option}>
                        {option}
                    </button>
                )
            })}
        </div>
    );

}

export default PeopleSelectorWidget;